import React from "react";
import { Link } from "react-router-dom";

const GameSliderHeader = ({ title, to, sliderRef }) => (
  <div className="slider-heading">
    <h3>{title}</h3>
    <div className="slider-heading-actions">
      {to ? (
        <Link to={to} className="more-game">
          All
        </Link>
      ) : null}
      <button
        type="button"
        className="game-nav game-prev"
        aria-label={`Previous ${title}`}
        onClick={() => sliderRef?.current?.slickPrev()}
      />
      <button
        type="button"
        className="game-nav game-next"
        aria-label={`Next ${title}`}
        onClick={() => sliderRef?.current?.slickNext()}
      />
    </div>
  </div>
);

export default GameSliderHeader;
